import React from "react";
import { Stack, Typography } from "@mui/material";

import { contactInfoMock } from "../model/constants";

export const ContactInfo: React.FC = () => {
  return (
    <Stack
      direction="column"
      justifyContent="space-between"
      alignItems="flex-start"
      gap={2}
    >
      {contactInfoMock.map((contact, index) => (
        <Stack
          key={`${contact.title}-${index}`}
          direction="row"
          justifyContent="center"
          alignItems="flex-start"
          gap={2}
        >
          {contact.icon}

          <Stack
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            <Typography color="textSecondary">{contact.title}</Typography>
            <Typography color="primary">{contact.info}</Typography>
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
};
